import React from 'react';
import { ArrowLeft, Save, Loader2 } from 'lucide-react';
import LoadingSpinner from '../LoadingSpinner';

const ExamenFormActions = ({ 
  onCancel, 
  onSubmit, 
  loading = false, 
  isValid = true 
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0">
        {/* Actions principales */}
        <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            disabled={loading}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Annuler
          </button>
          
          <button
            type="submit"
            onClick={onSubmit}
            disabled={loading || !isValid}
            className={`inline-flex items-center justify-center px-8 py-3 rounded-lg font-medium transition-all duration-200 ${
              loading || !isValid
                ? 'bg-gray-400 text-white cursor-not-allowed'
                : 'bg-[#202654] text-white hover:bg-[#1a1f4a] hover:shadow-lg transform hover:-translate-y-0.5'
            }`}
          >
            {loading ? (
              <>
                <LoadingSpinner size="sm" className="mr-2" />
                Création en cours...
              </>
            ) : (
              <>
                <Save className="h-4 w-4 mr-2" />
                Créer l'examen
              </>
            )}
          </button>
        </div>

        {/* Statut de validation */}
        <div className="flex items-center space-x-2">
          {isValid ? (
            <div className="flex items-center text-green-600">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
              <span className="text-sm font-medium">Formulaire valide</span>
            </div>
          ) : (
            <div className="flex items-center text-orange-600">
              <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
              <span className="text-sm font-medium">Formulaire incomplet</span>
            </div>
          )}
        </div>
      </div>

      {/* Message informatif */}
      <div className="mt-4 p-4 bg-gray-50 rounded-lg">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <div className="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center">
              <span className="text-blue-600 text-xs">💾</span>
            </div>
          </div>
          <div className="ml-3">
            <p className="text-sm text-gray-600">
              <strong>Avant de créer:</strong> Vérifiez que toutes les informations sont correctes. 
              L'examen sera sauvegardé avec toutes ses sessions et créneaux.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamenFormActions; 